import { Box, Flex, Text, Heading, Image } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import { Footer } from "../components/Footer";

import Logo from "../assets/images/logo.png";

export const Privacy = () => {
  const navigate = useNavigate();

  const headerStyle = {
    fontSize: "20px",
    color: "#000",
    fontFamily: "LeagueSpartan",
    mb: "10px",
  };

  const bodyStyle = {
    fontSize: "18px",
    color: "#5A5365",
    fontFamily: "LeagueSpartan",
    fontWeight: 300,
  };

  return (
    <Box py="50px" bg="linear-gradient(#FAF9F5 20%, #D8F1F2 80%)">
      <Image
        src={Logo}
        h={"48px"}
        objectFit={"cover"}
        justifySelf={"center"}
        onClick={() => navigate("/")}
        cursor={"pointer"}
      />

      <Box
        pt={{ base: "60px", lg: "157px" }}
        px={{ base: "16px", lg: "200px" }}
      >
        <Heading
          fontSize={{ base: "32px", lg: "64px" }}
          textAlign={{ base: "center", lg: "left" }}
          fontWeight={700}
          fontFamily={"LeagueSpartan"}
          color={"#19202D"}
        >
          Privacy Policy
        </Heading>

        <Text
          fontSize={{ base: "16px", lg: "24px" }}
          textAlign={{ base: "center", lg: "left" }}
          fontFamily={"LeagueSpartan"}
          color={"#19202D"}
          mt="20px"
        >
          Last updated: April 16, 2024
        </Text>

        <Box pt={{ base: "60px", lg: "93px" }}>
          <Flex flexDir={"column"} gap={"40px"}>
            <Box>
              <Text style={headerStyle}>AGREEMENT TO OUR LEGAL TERMS</Text>

              <Text style={bodyStyle}>
                We are Book-d Ltd, doing business as Book-d ('Company', 'we',
                'us', or 'our'), a company registered in the United Kingdom at
                86-90 Paul St, London EC2A 4NE, UK, London, England EC2A 4NE. We
                operate the website https://book-d.co.uk (the 'Site'), as well
                as any other related products and services that refer or link to
                these legal terms (the 'Legal Terms') (collectively, the
                'Services').
              </Text>
            </Box>

            <Text style={bodyStyle}>
              Book-d is a marketplace connecting the BIPOC community to beauty
              professionals that cater to their unique needs, while making the
              booking process as seamless as possible. The platform is also
              designed for beauty professionals and business owners to manage
              their businesses and increase visibility with their target
              customers. You can contact us by phone at info@bookd.co.uk, email
              at info@book-d.co.uk, or by mail to 86-90 Paul St, London EC2A
              4NE, UK, London, England EC2A 4NE, United Kingdom.l terms (the
              'Legal Terms') (collectively, the 'Services').
            </Text>

            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((term, index) => (
              <Flex flexDir={"column"} gap={"40px"} key={index}>
                <Box>
                  <Text style={headerStyle}>{index + 1}. OUR SERVICES</Text>

                  <Text style={bodyStyle}>
                    We are Book-d Ltd, doing business as Book-d ('Company',
                    'we', 'us', or 'our'), a company registered in the United
                    Kingdom at 86-90 Paul St, London EC2A 4NE, UK, London,
                    England EC2A 4NE. We operate the website
                    https://book-d.co.uk (the 'Site'), as well as any other
                    related products and services that refer or link to these
                    legal terms (the 'Legal Terms') (collectively, the
                    'Services').
                  </Text>
                </Box>

                <Text style={bodyStyle}>
                  Book-d is a marketplace connecting the BIPOC community to
                  beauty professionals that cater to their unique needs, while
                  making the booking process as seamless as possible. The
                  platform is also designed for beauty professionals and
                  business owners to manage their businesses and increase
                  visibility with their target customers. You can contact us by
                  phone at info@bookd.co.uk, email at info@book-d.co.uk, or by
                  mail to 86-90 Paul St, London EC2A 4NE, UK, London, England
                  EC2A 4NE, United Kingdom.
                </Text>
              </Flex>
            ))}
          </Flex>
        </Box>
      </Box>

      <Footer />
    </Box>
  );
};
